import { Component, effect, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateTimeRangeFieldsComponent } from '@shared/components/date-time-range-fields/date-time-range-fields.component';
import { IDateTimeRangeForm } from '@shared/components/date-time-range-fields/date-time-range-fields.interface';
import { IBriefStepState } from '../brief-step.interface';
import { TBriefBasicsDatesValue, resolveDefaultBasicsDatesValue } from './basics-dates-step.util';

export type { TBriefBasicsDatesValue } from './basics-dates-step.util';

@Component({
  imports: [ReactiveFormsModule, DateTimeRangeFieldsComponent],
  selector: 'app-brief-basics-dates-step',
  templateUrl: './basics-dates-step.component.html',
})
export class BriefBasicsDatesStepComponent {
  public readonly initialValue = input.required<TBriefBasicsDatesValue>();
  public readonly stateChange = output<IBriefStepState<TBriefBasicsDatesValue>>();

  public readonly form = new FormGroup<IDateTimeRangeForm>({
    endDate: new FormControl<Date | null>(null, Validators.required),
    endTime: new FormControl<Date | null>(null, Validators.required),
    startDate: new FormControl<Date | null>(null, Validators.required),
    startTime: new FormControl<Date | null>(null, Validators.required),
  });

  constructor() {
    effect(() => {
      this.form.patchValue(resolveDefaultBasicsDatesValue(this.initialValue()), { emitEvent: false });
      this.form.markAllAsTouched();
      this.emitState();
    });

    this.form.valueChanges.subscribe(() => this.emitState());
  }

  private emitState(): void {
    this.stateChange.emit({ valid: this.form.valid, value: this.form.getRawValue() });
  }
}
